import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["picker", "hex"]

  fromPicker() {
    this.hexTarget.value = this.pickerTarget.value.toUpperCase()
    this.hexTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  fromHex() {
    const value = this.hexTarget.value.trim()
    if (/^#[0-9A-Fa-f]{6}$/.test(value)) this.pickerTarget.value = value
  }

  pick(event) {
    const hex = event.currentTarget.dataset.hex
    if (!hex) return
    this.hexTarget.value = hex
    this.pickerTarget.value = hex
    this.hexTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
